import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { Subject, filter, takeUntil } from 'rxjs';
import { DataService } from '../../services/data.service';
import { AuthService } from '../../services/auth.service';
import { UserDocument } from '../../interfaces/user-document.interface';

export interface NavItem {
  label: string;
  route: string;
  icon: string;
}

export interface NavGroup {
  label: string;
  icon: string;
  items: NavItem[];
}

// Chỉ các route đã có implementation thực tế
const NAV_GROUPS: NavGroup[] = [
  {
    label: 'Tổng quan',
    icon: 'layout-dashboard',
    items: [
      { label: 'Dashboard', icon: 'gauge', route: '/' }
    ]
  },
  {
    label: 'Quản lý nội dung',
    icon: 'list-tree',
    items: [
      { label: 'Danh mục dịch vụ', icon: 'list-tree',  route: '/service-management' },
      { label: 'Quản lý món ăn',   icon: 'text',        route: '/food-management' },
      { label: 'Nhiệm vụ & Quiz',  icon: 'badge-check', route: '/mission-management' },
      { label: 'Quảng cáo',        icon: 'megaphone',   route: '/ad-management' }
    ]
  },
  {
    label: 'Tài chính',
    icon: 'wallet',
    items: [
      { label: 'Cấu hình kinh tế', icon: 'sliders-horizontal', route: '/price-editor' },
      { label: 'Rút tiền & chi trả', icon: 'banknote',          route: '/payment-center' }
    ]
  },
  {
    label: 'Vận hành',
    icon: 'shield-alert',
    items: [
      { label: 'Kiểm duyệt cộng đồng', icon: 'shield-alert', route: '/controlCenter' }
    ]
  },
  {
    label: 'Hệ thống',
    icon: 'settings',
    items: [
      { label: 'AI & Prompt', icon: 'sparkles', route: '/ai-settings' }
    ]
  }
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
  standalone: true,
  imports: [CommonModule, RouterModule]
})
export class SidebarComponent implements OnInit, OnDestroy {
  navGroups = NAV_GROUPS;
  currentUrl = '/';
  userData: UserDocument | null = null;
  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    public dataService: DataService,
    public authService: AuthService
  ) {}

  ngOnInit(): void {
    this.currentUrl = this.router.url;
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      takeUntil(this.destroy$)
    ).subscribe((e: any) => {
      this.currentUrl = e.urlAfterRedirects;
    });

    this.dataService.userData$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(u => this.userData = u);
  }

  isActive(route: string): boolean {
    if (route === '/') return this.currentUrl === '/';
    return this.currentUrl.startsWith(route);
  }

  navigate(route: string): void {
    this.router.navigate([route]);
  }

  iconSrc(name: string, active: boolean): string {
    return `assets/icons/${name}-${active ? '0E7A7D' : '6E7570'}.svg`;
  }

  groupIconSrc(name: string): string {
    return `assets/icons/${name}-8A9083.svg`;
  }

  signOut(): void {
    this.authService.signOut();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
